import PropTypes from 'prop-types';
import {
  MenuItem,
  Select,
  OutlinedInput,
  FormControl,
  InputLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: 8,
  '& .MuiInputLabel-root': {
    fontSize: '0.85rem',
    fontWeight: 600,
    top: '-2px',
  },
  '& .MuiSelect-select': {
    fontSize: '0.9rem',
    padding: '10px 12px',
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: 8,
  transition: 'all 0.25s ease',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.divider,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}25`,
  },
}));

const FilterSelectInput = ({
  label,
  name = 'group',
  value,
  data,
  onInputChange,
  sx,
  ...rest
}) => {
  const handleInputChange = (e) => {
    const selectedValue = e.target.value;
    onInputChange(selectedValue);
  };

  return (
    <StyledFormControl
      sx={{
        width: { xs: '100%', sm: '15%' },
        mr: { xs: 1, sm: 3 },
        ...sx,
      }}
      {...rest}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <StyledSelect
        name={name}
        input={<OutlinedInput label={label} />}
        labelId={`${name}-label`}
        value={value}
        onChange={handleInputChange}
      >
        {data.map((item) => (
          <MenuItem value={item.id} key={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
};

FilterSelectInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  data: PropTypes.array.isRequired,
  onInputChange: PropTypes.func,
  sx: PropTypes.object,
};

export default FilterSelectInput;
